/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPressKitBodyGuidelineText
 */
export interface PostPressKitBodyGuidelineText {
    /**
     * エラー箇所を特定するために必要な各オブジェクトのID
     * @type {string}
     * @memberof PostPressKitBodyGuidelineText
     */
    objectId: string;
    /**
     * ガイドラインのテキスト。削除したい場合は空文字でリクエストする
     * @type {string}
     * @memberof PostPressKitBodyGuidelineText
     */
    content: string;
}

/**
 * Check if a given object implements the PostPressKitBodyGuidelineText interface.
 */
export function instanceOfPostPressKitBodyGuidelineText(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectId" in value;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function PostPressKitBodyGuidelineTextFromJSON(json: any): PostPressKitBodyGuidelineText {
    return PostPressKitBodyGuidelineTextFromJSONTyped(json, false);
}

export function PostPressKitBodyGuidelineTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBodyGuidelineText {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectId': json['__object_id'],
        'content': json['content'],
    };
}

export function PostPressKitBodyGuidelineTextToJSON(value?: PostPressKitBodyGuidelineText | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '__object_id': value.objectId,
        'content': value.content,
    };
}

